<template>
  <div class="ticket-detail-wrapper">
    <display-navigation
      v-show="ticketDetail.ticket"
      :path="spotId === '0' ? '' : 'tickets_list'"
      title="门票详情"
    />
    <!-- <display-ticket-cover :value="ticketDetail.logo" /> -->
    <display-swipe :items="ticketDetail.slide || []" />
    <field-group
      :value="{ ...ticketDetail, left }"
      :united="united"
      @dateChange="getSeats"
      @change="handleFieldChange"
    />
    <display-description :value="ticketDetail.explain" />
    <submit-bar :price="price * 100" :loading="loading" @submit="handleSubmit" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { getTicketDetail, getTicketDetailSeats } from '../../api/api-ticket';

import { createOrder } from '../../api/api-user';

// import DisplayTicketCover from '../../components/DisplayTicketCover.vue';
import DisplayNavigation from '../../components/DisplayNavigation.vue';
import DisplayDescription from '../../components/DisplayDescription.vue';
import DisplaySwipe from '../../components/DisplaySwipe';
import FieldGroup from './FieldGroup';
import SubmitBar from './SubmitBar';

export default {
  name: 'TicketDetail',
  components: {
    DisplaySwipe,
    // DisplayTicketCover,
    DisplayNavigation,
    DisplayDescription,
    FieldGroup,
    SubmitBar,
  },
  data() {
    return {
      form: {},
      loading: false,
      ticketDetail: {},
      left: undefined,
    };
  },
  computed: {
    ...mapGetters(['user', 'spotId']),
    ticketId() {
      return this.$route.query.id;
    },
    ticketType() {
      if (this.$route.query.ticketType) {
        return this.$route.query.ticketType;
      }
      return {};
    },
    united() {
      return this.$route.query.united;
    },
    price() {
      return ((this.form.price || 0) * (this.form.count || 0)).toFixed(2);
    },
    infoNeeded() {
      return this.ticketDetail.message_name === 1 || this.ticketDetail.message_idcard === 1;
    },
  },
  async created() {
    try {
      const id = await this.checkTicketId();
      const detail = await getTicketDetail({ id, united: this.united });
      this.ticketDetail = { ...detail, ticketType: this.ticketType };
    } catch {
      this.back();
    }
  },
  methods: {
    async checkTicketId() {
      return new Promise((resolve, reject) => (this.ticketId ? resolve(this.ticketId) : reject()));
    },
    back() {
      this.$router.push({ name: 'tickets_list' });
    },
    handleFieldChange(form) {
      this.ticketDetail = { ...this.ticketDetail, display_price: form.price, price: form.price };
      this.form = form;
    },
    handlePayoffByWechat(data) {
      return new Promise((resolve, reject) => {
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', data, res => {
          if (res.err_msg === 'get_brand_wcpay_request:ok') {
            resolve();
            this.$router.push({ name: 'orders_list' });
          } else {
            reject(new Error(res.errMsg));
          }
        });
      });
    },
    handlePayoffByAlipay(data) {
      return new Promise((resolve, reject) => {
        window.AlipayJSBridge.call('tradePay', data, res => {
          resolve();
          if (res.resultCode === '9000') {
            this.$router.push({ name: 'orders_list' });
          } else {
            reject(new Error(res.resultCode));
          }
        });
      });
    },
    choosePayment(data) {
      if (window.WeixinJSBridge) {
        return this.handlePayoffByWechat(data);
      }
      if (window.AlipayJSBridge) {
        return this.handlePayoffByAlipay({
          tradeNO: data,
        });
      }
      return undefined;
    },
    async handleSubmit() {
      try {
        const fields = await this.checkFields();
        this.loading = true;
        const data = await createOrder(fields, this.united);
        if (data && data.free === 1) {
          this.$router.push({ name: 'orders_list' });
        } else if (data) {
          await this.choosePayment(data);
        }
      } catch (err) {
        this.$toast.fail(err.message);
      } finally {
        this.loading = false;
      }
    },
    async getSeats(date) {
      const { left } = await getTicketDetailSeats({
        date,
        id: this.ticketId,
        united: this.united,
      });
      this.left = left;
    },
    async checkFields() {
      return new Promise((resolve, reject) => {
        const { tel, date, shop, count, info, reserve } = this.form;
        if (this.ticketDetail.message_mobile && !/^1[3456789]\d{9}$/.test(tel))
          reject(new Error('请输入正确的手机号'));
        if (!date) reject(new Error('未选择日期'));
        // if (!reserve.start_time) reject(new Error('未选择时间段'));
        if (!(info && info.length)) reject(new Error('未选择购票数量'));
        if (this.infoNeeded)
          info.forEach(item => {
            try {
              if (this.ticketDetail.message_name === 1 && this.ticketDetail.message_idcard === 1) {
                const { name, identityNo, noType } = item;
                // if (this.ticketDetail.style === 2) {
                //   if (!item.discountCardNo) reject(new Error('未输入优惠卡号'));
                // }
                if (!name) reject(new Error('未输入姓名'));
                if ((noType === '1' && !/\d{17}[0-9Xx]$/.test(identityNo)) || !identityNo)
                  reject(new Error('请输入正确的证件号'));
              } else if (
                this.ticketDetail.message_name === 1 &&
                this.ticketDetail.message_idcard === 0
              ) {
                const { name } = item;
                if (!name) reject(new Error('未输入姓名'));
              } else if (
                this.ticketDetail.message_name === 0 &&
                this.ticketDetail.message_idcard === 1
              ) {
                const { identityNo, noType } = item;
                if ((noType === '1' && !/\d{17}[0-9Xx]$/.test(identityNo)) || !identityNo)
                  reject(new Error('请输入正确的证件号'));
              }
            } catch {
              reject(new Error('未输入用户信息'));
            }
          });
        const uid = window.sessionStorage.getItem('__shareid');
        resolve({
          tel,
          uid,
          shop,
          date,
          reserve,
          info,
          count,
          id: this.ticketId,
          ticketTypeId: this.ticketType ? this.ticketType.id : '',
        });
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ticket-detail-wrapper {
  padding-bottom: 50px;
  .amount-wrapper {
    margin: 46px 0;
    text-align: center;
    .amount {
      font-size: 48px;
    }
    .dollar {
      font-size: 32px;
    }
  }
  .balance {
    padding-right: 12px;
  }
}
</style>
